export default __webpack_public_path__ + "static/chckup-vs-allydvm-8a4eac938c2831bba7744d7f13cbe459.png";